import { render, staticRenderFns } from "./polize.vue?vue&type=template&id=423bdfe6&"
import script from "./polize.vue.ts?vue&type=script&lang=ts&"
export * from "./polize.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports